<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :title="computedTitle"
    dialog-width="35%"
    min-body-height="400px"
    header-shadow
    @agree="editDictHandler"
    agree-text="dialog.agreeSave"
    :disagree-text="currentDict.read_only ? 'dialog.close' : 'dialog.disagree'"
    @modalClosed="closeDictAdding"
    :loading="isLoading"
    :isValid="computedIsValid"
    :isAgreeVisible="!currentDict.read_only"
  >
    <template #body>
      <v-col cols="12">
        <v-row no-gutters class="justify-center align-baseline">
          <v-col cols="5" style="text-align: left">
            <span> {{ $i18n.t('dialog.dictName') }}: </span>
          </v-col>
          <v-col cols="5" class="dict-value">
            <data-input
              class="pl-4"
              v-model="currentDict.name"
              :disabled="currentDict.read_only"
              :data-type="dataTypeText"
            >
            </data-input>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row no-gutters class="justify-center align-baseline">
          <v-col cols="5" style="text-align: left">
            <v-row no-gutters class="font--text">{{ $i18n.t('dialog.dictType') }}:</v-row>
          </v-col>
          <v-col cols="5">
            <data-input
              class="pl-4"
              :menu-props="{ offsetY: true }"
              v-model="currentDict.data_type"
              :items="allowedDataTypes"
              @change="checkDictsTypes"
              item-text="verbose_name"
              item-value="name"
              :disabled="!currentDict.isNew"
              :data-type="dataType"
            >
            </data-input>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row no-gutters justify="center" class="pt-5 border--top">
          <v-col cols="5" style="text-align: left" class="pt-2">
            <v-row no-gutters>{{ $i18n.t('dialog.dictValue') }}:</v-row>
            <v-row no-gutters class="title-subheader">
              {{ $i18n.t('dialog.dictValueSub1') }} <br />
              {{ $i18n.t('dialog.dictValueSub2') }}</v-row
            >
            <v-row no-gutters v-if="!currentDict.read_only">
              <v-col cols="12">
                <v-checkbox v-model="hasColors" hide-details>
                  <template #label>
                    <v-row no-gutters class="text-body-2" style="color: #202124 !important">
                      {{ $i18n.t('dialog.body.colorCodeTheValues') }}
                    </v-row>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="!currentDict.read_only">
              <v-col cols="12">
                <v-checkbox v-model="hasPictures" hide-details>
                  <template #label>
                    <v-row no-gutters class="text-body-2" style="color: #202124 !important">
                      {{ $i18n.t('dialog.body.pictureCodeTheValues') }}
                    </v-row>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="7">
            <v-list>
              <v-form ref="addedValuesForm" v-model="isAddedValuesFormValid">
                <draggable v-model="currentDict.values">
                  <v-list-item v-for="(val, idx) in currentDict.values" :key="idx" class="dict-element">
                    <v-list-item-content class="pa-0">
                      <v-row
                        no-gutters
                        align="center"
                        :justify="colorsVisible || picturesVisible ? 'space-between' : 'end'"
                        style="height: 51px"
                      >
                        <v-col cols="1" class="pa-0" v-if="colorsVisible">
                          <data-input
                            v-model="currentDict.colors[idx]"
                            :data-type="{ name: 'color' }"
                            @input="setColor($event, idx)"
                          />
                        </v-col>
                        <v-col cols="2" class="pa-0" v-if="picturesVisible">
                          <file-input
                            :ref="`picture-${idx}`"
                            :options="dropzoneOptions"
                            @fileAdded="setPicture($event, idx)"
                            @error="onError(idx)"
                          >
                            <template #uploadContent>
                              <dictionaries-picture :url="currentDict.picturesUrls[idx]" />
                            </template>
                          </file-input>
                        </v-col>
                        <v-col :cols="setColums" class="pa-0 dict-value">
                          <dictonaries-editing-row
                            v-model="currentDict.values[idx]"
                            :data-type="dictDataType"
                            :rules="rules"
                            :disabled="currentDict.read_only"
                          >
                          </dictonaries-editing-row>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action v-if="!currentDict.read_only" class="ma-0 ml-1">
                      <v-btn x-small icon @click="deleteDict(idx)">
                        <v-icon medium color="rgba(0,0,0,0.7)">
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </draggable>
              </v-form>
              <v-list-item v-if="!currentDict.read_only" class="pb-5 dict-element">
                <v-list-item-content class="pa-0">
                  <v-form ref="newValueForm" v-model="isNewValueValid">
                    <v-row
                      no-gutters
                      align="center"
                      :justify="colorsVisible || picturesVisible ? 'space-between' : 'end'"
                      style="height: 51px"
                    >
                      <v-col cols="1" class="pa-0" v-if="colorsVisible">
                        <data-input v-model="dictColor" :data-type="{ name: 'color' }" />
                      </v-col>
                      <v-col cols="2" class="pa-0" v-if="picturesVisible">
                        <file-input
                          ref="picture"
                          :options="dropzoneOptions"
                          @fileAdded="setPicture($event, 'new')"
                          @error="onError('new')"
                        >
                          <template #uploadContent>
                            <dictionaries-picture :url="dictPictureUrl" />
                          </template>
                        </file-input>
                      </v-col>
                      <v-col :cols="setColums" class="pa-0 dict-value">
                        <data-input v-model="dictValue" :data-type="{ name: currentDict.data_type }" :rules="rules" />
                      </v-col>
                    </v-row>
                    <v-row v-if="currentDict.data_type !== 'datetime'" no-gutters class="new-value-subheader">
                      <v-spacer />
                      <v-col :cols="12" class="text-right">
                        {{ $i18n.t('dialog.dictHint') }}
                      </v-col>
                    </v-row>
                  </v-form>
                </v-list-item-content>
                <v-list-item-action class="ma-0 ml-1">
                  <v-btn
                    small
                    icon
                    :style="`cursor: ${isNewValueValid ? 'pointer' : 'default'}`"
                    style="width: auto"
                    class="mb-5"
                    @click="isNewValueValid ? pushDict() : ''"
                  >
                    <v-icon :color="isNewValueValid ? 'success' : 'disable'">
                      mdi-check
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <main-dialog
          v-if="isAcceptDataTypeChangeLoaded"
          :is-visible.sync="isAcceptDataTypeChangeVisible"
          :title="$i18n.t('dialog.changeDictType')"
          :body="$i18n.t('dialog.confirmDictTypeChange')"
          agree-text="dialog.agreeChange"
          @agree="changeDictType"
          @modalClosed="discardDictType"
        ></main-dialog>
      </v-col>
    </template>
  </main-large-dialog>
</template>

<script>
import { call, get } from 'vuex-pathify';
import draggable from 'vuedraggable';

import DataInput from '@/components/DataInput';
import DictonariesEditingRow from '@/components/DictonariesEditingRow';
import FileInput from '@/components/FileInput';
import DictionariesPicture from '@/components/DictionariesPicture';
import MainLargeDialog from '@/components/MainLargeDialog';

export default {
  name: 'DictonariesEditing',
  components: {
    DataInput,
    MainDialog: () => import('@/components/MainDialog'),
    MainLargeDialog,
    DictonariesEditingRow,
    draggable,
    FileInput,
    DictionariesPicture,
  },
  props: {
    isVisible: {
      required: true,
      type: Boolean,
    },
    currentDict: {
      required: true,
      type: Object,
    },
  },
  data: vm => ({
    dataType: {
      name: 'select',
    },
    dataTypeText: {
      name: 'text',
    },
    dictColor: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
    dictPicture: undefined,
    dictPictureUrl: '',
    dictValue: '',
    allowedDictsTypes: ['text', 'integer', 'decimal', 'datetime'],
    preventDataType: '',
    isAcceptDataTypeChangeVisible: false,
    isAcceptDataTypeChangeLoaded: false,
    valuesCopy: [],
    isLoading: false,
    isNewValueValid: false,
    isAddedValuesFormValid: false,
    rules: [v => !!v || v === 0 || vm.$i18n.t('rules.required')],
    hasColors: false,
    hasPictures: false,
  }),
  computed: {
    setColums() {
      if (this.colorsVisible && this.picturesVisible) {
        return 8;
      } else if (this.picturesVisible) {
        return 9;
      } else if (this.colorsVisible) {
        return 10;
      } else {
        return 11;
      }
    },
    dropzoneOptions() {
      return {
        url: '/',
        autoProcessQueue: false,
        maxFiles: 1,
        acceptedFiles: '.png,.jpg,.jpeg',
        uploadMultiple: false,
        init: function() {
          this.on('addedfile', function() {
            this.removeAllFiles(true);
          });
        },
      };
    },
    dataTypes: get('layers/dataTypes'),
    allowedDataTypes() {
      return this.dataTypes.filter(dT => this.allowedDictsTypes.includes(dT.name));
    },
    colorsVisible() {
      return this.hasColors && !this.currentDict.read_only;
    },
    picturesVisible() {
      return this.hasPictures && !this.currentDict.read_only;
    },
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    computedIsValid() {
      return this.isAddedValuesFormValid && !this.currentDict.read_only;
    },
    computedTitle() {
      return this.currentDict?.isNew
        ? this.$i18n.t('dialog.addDict')
        : this.$i18n.t(this.currentDict.read_only ? 'dialog.title.predefinedDict' : 'dialog.editDict', {
            name: this.currentDict.name,
          });
    },
    dictDataType() {
      return {
        name: this.currentDict.data_type,
      };
    },
  },
  methods: {
    setColor(value, idx) {
      this.currentDict.colors[idx] = value;
      this.$forceUpdate();
    },
    setPicture(file, idx) {
      this.$refs.picture.$refs.dropzone.removeAllFiles(file);
      const URL = window.URL || window.webkitURL;
      const url = URL.createObjectURL(file);
      if (idx === 'new') {
        this.dictPicture = file;
        this.dictPictureUrl = url;
      } else {
        this.currentDict.pictures[idx] = file;
        this.currentDict.picturesUrls[idx] = url;
        this.$forceUpdate();
      }
    },
    onError(idx) {
      if (idx === 'new') {
        this.dictPicture = undefined;
        this.dictPictureUrl = '';
      } else {
        this.currentDict.pictures[idx] = undefined;
        this.currentDict.picturesUrls[idx] = '';
      }
    },
    getDataTypes: call('layers/getDataTypes'),
    postDict: call('admin/postDictionary'),
    putDict: call('admin/putDictionary'),
    async editDictHandler() {
      if (!this.currentDict.name) {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.nameRequired'),
        });
      } else if (!this.currentDict.data_type) {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.dataTypeRequired'),
        });
      } else if (this.currentDict.values.length < 1) {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.dictionaryValuesRequired'),
        });
      } else if (this.currentDict.values.length < 2) {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.dictionaryTwoValuesRequired'),
        });
      } else if (this.hasPictures && !this.currentDict.pictures.every(picture => Boolean(picture?.name))) {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.dictionaryAllPicturesRequired'),
        });
      } else {
        this.isLoading = true;
        const emptyFile = new File([''], '');
        let { name, values, colors, pictures } = this.currentDict;
        colors = this.colorsVisible ? colors : colors.map(() => null);
        pictures = this.picturesVisible ? pictures : pictures.map(() => emptyFile);

        const formData = new FormData();
        formData.append('name', name);
        formData.append('values', JSON.stringify(values));
        formData.append('colors', JSON.stringify(colors));
        for (let picture of pictures) {
          formData.append('files', picture);
        }
        try {
          if (this.currentDict.isNew) {
            formData.append('data_type', this.currentDict.data_type);
            await this.postDict(formData);
          } else {
            const data = { formData, id: this.currentDict.id };
            await this.putDict(data);
          }
          this.isLoading = false;
          this.computedIsVisible = false;
          this.dictPicture = undefined;
          this.dictPictureUrl = '';
          this.$refs.picture?.$refs.dropzone?.removeAllFiles();
        } catch {
          this.isLoading = false;
        }
      }
    },
    closeDictAdding() {
      this.dictValue = '';
      this.dictPictureUrl = '';
    },
    deleteDict(idx) {
      this.$delete(this.currentDict.values, idx);
      this.$delete(this.currentDict.colors, idx);
      this.$delete(this.currentDict.pictures, idx);
      this.$delete(this.currentDict.picturesUrls, idx);
    },
    pushDict() {
      if (this.currentDict.values.includes(this.dictValue)) {
        this.$store.set('snackbar/PUSH_MESSAGE!', {
          message: this.$i18n.t('dialog.valuesAlreadyAdded'),
        });
      } else if (!String(this.dictValue).trim()) {
        this.$store.set('snackbar/PUSH_MESSAGE!', {
          message: this.$i18n.t('dialog.emptyValue'),
        });
      } else {
        this.currentDict.values.push(this.dictValue);
        this.currentDict.colors.push(this.dictColor);
        this.currentDict.pictures.push(this.dictPicture);
        this.currentDict.picturesUrls.push(this.dictPictureUrl);
        this.dictValue = '';
        this.dictColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        this.dictPicture = undefined;
        this.dictPictureUrl = '';
        this.$refs?.newValueForm?.resetValidation();
      }
    },
    checkDictsTypes() {
      this.valuesCopy = JSON.parse(JSON.stringify(this.currentDict.values));
      if (this.currentDict.values.length > 0) {
        this.isAcceptDataTypeChangeLoaded = true;
        this.isAcceptDataTypeChangeVisible = true;
      } else {
        this.preventDataType = this.currentDict.data_type;
        this.dictValue = '';
      }
    },
    changeDictType() {
      const newValues = [];
      if (this.currentDict.data_type === 'integer') {
        if (this.preventDataType === 'datetime') {
          this.currentDict.values = newValues;
          this.isAcceptDataTypeChangeVisible = false;
          return;
        }
        for (let v of this.currentDict.values) {
          const parseInt = Number.parseInt(v);
          if (parseInt && !newValues.includes(parseInt)) {
            newValues.push(parseInt);
          }
        }
        this.currentDict.values = newValues;
      } else if (this.currentDict.data_type === 'decimal') {
        if (this.preventDataType === 'datetime') {
          this.currentDict.values = newValues;
          this.isAcceptDataTypeChangeVisible = false;
          return;
        }
        for (let v of this.currentDict.values) {
          const parseFloat = Number.parseFloat(v);
          if (parseFloat && !newValues.includes(parseFloat)) {
            newValues.push(parseFloat);
          }
        }
        this.currentDict.values = newValues;
      } else if (this.currentDict.data_type === 'datetime') {
        for (let v of this.currentDict.values) {
          if (typeof v === 'string') {
            const parseDate = new Date(v);
            if (parseDate.toString() !== 'Invalid Date') {
              newValues.push(v);
            }
          }
        }
        this.currentDict.values = newValues;
      }
      this.dictValue = '';
      this.isAcceptDataTypeChangeVisible = false;
      this.preventDataType = this.currentDict.data_type;
    },
    discardDictType() {
      this.currentDict.data_type = this.preventDataType;
      this.currentDict.values = this.valuesCopy;
    },
  },
  watch: {
    hasColors(nV) {
      if (nV) {
        this.currentDict.colors = this.currentDict.colors.map(color => color || this.$_getRandomColor());
      }
    },
    hasPictures(nV) {
      if (nV) {
        const emptyFile = new File([''], '');
        this.currentDict.pictures = this.currentDict.pictures.map(picture => picture || emptyFile);
        this.currentDict.picturesUrls = this.currentDict.picturesUrls.map(url => url || '');
      }
    },
    isVisible(nv) {
      if (nv) {
        this.preventDataType = this.currentDict.data_type;
        this.$refs.newValueForm && this.$refs.newValueForm.resetValidation();
        this.$refs.addedValuesForm && this.$refs.addedValuesForm.resetValidation();
        this.hasColors = this.currentDict.colors?.length > 0 && this.currentDict.colors.every(color => Boolean(color));
        this.hasPictures =
          this.currentDict.picturesUrls?.length > 0 &&
          this.currentDict.picturesUrls.every(pictureUrl => Boolean(pictureUrl));
      }
    },
  },
  mounted() {
    this.preventDataType = this.currentDict.data_type;
    this.$refs.newValueForm && this.$refs.newValueForm.resetValidation();
    this.$refs.addedValuesForm && this.$refs.addedValuesForm.resetValidation();
    this.hasColors = this.currentDict.colors?.length > 0 && this.currentDict.colors.every(color => Boolean(color));
    this.hasPictures =
      this.currentDict.picturesUrls?.length > 0 &&
      this.currentDict.picturesUrls.every(pictureUrl => Boolean(pictureUrl));
    if (this.dataTypes.length < 1) {
      this.getDataTypes();
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .dict-value > .v-input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
  }
  .dict-value {
    .v-text-field__slot input {
      padding-bottom: 0;
    }
    .v-text-field__details {
      display: none;
    }
  }
  .dict-value-new {
    .v-messages__message {
      font-style: italic;
    }
    .v-text-field__slot input {
      padding-bottom: 0;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .v-card__title {
    background-color: red !important;
  }
  .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0;
  }
}
.dict-element {
  text-align: left;
}
.title-subheader {
  font-family: Roboto;
  font-style: italic;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  font-style: italic;
  color: rgba(0, 0, 0, 0.59);
}
.border--top {
  @include border(top);
}
.new-value-subheader {
  font-family: Roboto;
  font-style: italic;
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.59);
}
</style>
